import { render, staticRenderFns } from "./GoodsTagManage.vue?vue&type=template&id=b5bf2916&"
import script from "./GoodsTagManage.vue?vue&type=script&lang=js&"
export * from "./GoodsTagManage.vue?vue&type=script&lang=js&"
import style0 from "./GoodsTagManage.vue?vue&type=style&index=0&lang=scss&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports